var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSubway = function SvgIcSubway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M11 1H5a1.5 1.5 0 0 0-1.5 1.5v8A1.5 1.5 0 0 0 5 12h6a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 11 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 2.5h3M11.5 4h-7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M5.5 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM10.5 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 14.5h7m-1-1L12 15m-6.5-1.5L4 15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIcSubway;